import React from "react";
import { Link } from "react-router-dom";
import { Cake, Instagram, Facebook, Mail, Phone, MapPin } from "lucide-react";
import { WhatsAppIcon } from "./WhatsAppButton";
import { CATEGORIES } from "../mock";
import { DELIVERY_AREAS, FESTIVE_OCCASIONS } from "../data/seoContent";

const Footer = () => {
  return (
    <footer className="bg-[#3A2417] text-[#F1E4D6] mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2 mb-4">
            <img src="/assets/globaltreats-logo.jpeg" alt="Globaltreats logo" className="w-11 h-11 rounded-full object-cover" />
            <div className="leading-tight">
              <span className="font-display text-2xl font-bold block">Globaltreats</span>
              <span className="font-script text-base text-[#E8A6B8] normal-case tracking-normal">Cake Creation by Swati</span>
            </div>
          </div>
          <p className="text-sm text-[#C9B4A2] leading-relaxed">
            Freshly baked, hand-decorated cakes delivered to your doorstep. Making every celebration sweeter since day one.
          </p>
          <div className="flex gap-3 mt-5">
            <a href="https://www.instagram.com/cakecreationbyswati?igsh=MXR6bmZicGV4djZueQ==" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 grid place-items-center hover:bg-[#D46A8A] transition-colors" aria-label="Instagram">
              <Instagram size={18} />
            </a>
            <a href="https://www.facebook.com/share/1CmWYA8sbF/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 grid place-items-center hover:bg-[#D46A8A] transition-colors" aria-label="Facebook">
              <Facebook size={18} />
            </a>
            <a href="https://wa.me/919264971235" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 grid place-items-center hover:bg-[#25D366] transition-colors" aria-label="WhatsApp">
              <WhatsAppIcon size={18} />
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-display text-lg font-semibold mb-4">Shop Cakes</h4>
          <ul className="space-y-2.5 text-sm text-[#C9B4A2]">
            {CATEGORIES.slice(1, 7).map((c) => (
              <li key={c.slug}><Link to={`/collections/${c.slug}`} className="hover:text-[#E8A6B8] transition-colors">{c.name}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg font-semibold mb-4">Company</h4>
          <ul className="space-y-2.5 text-sm text-[#C9B4A2]">
            <li><Link to="/collections/all" className="hover:text-[#E8A6B8]">All Cakes</Link></li>
            <li><Link to="/blog" className="hover:text-[#E8A6B8]">Journal &amp; Cake Ideas</Link></li>
            <li><Link to="/contact" className="hover:text-[#E8A6B8]">Contact Us</Link></li>
            <li><Link to="/track-order" className="hover:text-[#E8A6B8]">Track Order</Link></li>
            <li><Link to="/admin" className="hover:text-[#E8A6B8]">Admin</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg font-semibold mb-4">Get in touch</h4>
          <ul className="space-y-3 text-sm text-[#C9B4A2]">
            <li className="flex items-center gap-2"><Phone size={16} className="text-[#E8A6B8]" /> +91 92649 71235</li>
            <li className="flex items-center gap-2"><Mail size={16} className="text-[#E8A6B8]" /> globaltreatstradingllp@gmail.com</li>
            <li className="flex items-start gap-2"><MapPin size={16} className="text-[#E8A6B8] mt-0.5 shrink-0" /> Verona, Mahagun Moderne, Sector 78, Noida</li>
            <li className="flex items-start gap-2"><MapPin size={16} className="text-[#E8A6B8] mt-0.5 shrink-0" /> Globaltreats Trading LLP, Main Ghijjore Road, 1st Floor, Near TVS Showroom, Sector 53, Noida</li>
          </ul>
          <div className="mt-4 text-xs text-[#C9B4A2] bg-white/5 rounded-lg p-3">
            <span className="text-[#E8A6B8] font-medium">Delivery areas:</span> Noida, Greater Noida, Indirapuram (Ghaziabad)
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-6">
          <h4 className="text-sm font-semibold text-[#E8A6B8] mb-3">Seasonal Specials</h4>
          <div className="flex flex-wrap gap-x-4 gap-y-2 text-xs text-[#C9B4A2]">
            {FESTIVE_OCCASIONS.map((o) => (
              <Link key={o.slug} to={`/occasions/${o.slug}`} className="hover:text-[#E8A6B8] transition-colors">{o.name} in Noida</Link>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-6">
          <h4 className="text-sm font-semibold text-[#E8A6B8] mb-3">Cake Delivery Areas in Noida &amp; Greater Noida</h4>
          <div className="flex flex-wrap gap-x-4 gap-y-2 text-xs text-[#C9B4A2]">
            {DELIVERY_AREAS.map((a) => (
              <Link key={a.slug} to={`/cake-delivery/${a.slug}`} className="hover:text-[#E8A6B8] transition-colors">
                Cakes in {a.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 text-center text-xs text-[#C9B4A2]">
          © {new Date().getFullYear()} Globaltreats. All rights reserved. Baked with love.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
